import * as serviceContext from '../services/serviceContext';
import { BASE_URL_M_ADMIN } from "../config";

let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';

export async function userChangePasswordApi(data) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/usermaster/changepassword`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}